import React from 'react';
import Div from '../Element/Div/Div';
import Element from '../Element/Element';
import styles from './MarginSpace.module.scss';
import { CreateProps } from '../../types/utils/CreateProps';

type MarginSpaceProps = CreateProps<
  {
    /** If the view is narrow */
    narrow?: boolean;
    /** If the padding should be removed in the md and smaller screen size */
    noPaddingForSmallerThanMd?: boolean;
    /** If the padding should be removed in the sm and smaller screen size */
    noPaddingForSmallerThanSm?: boolean;
    /** HTML tag name: div, span, h1 etc */
    tagName?: keyof JSX.IntrinsicElements;
  },
  typeof Div
>;
// Alias for backwards compatibility
export type MarginSpaceAttributes = MarginSpaceProps;

const MarginSpace: React.FunctionComponent<MarginSpaceProps> = ({
  padding = {},
  narrow,
  noPaddingForSmallerThanMd,
  noPaddingForSmallerThanSm,
  className,
  children,
  tagName = 'div',
  ...props
}) => {
  const classNames = [
    styles.marginSpace,
    {
      [styles.marginSpace__narrow]: narrow,
      [styles.marginSpace__noPaddingForSmallerThanMd]: noPaddingForSmallerThanMd,
      [styles.marginSpace__noPaddingForSmallerThanSm]: noPaddingForSmallerThanSm,
    },
    className,
  ];

  const paddingWithHorizontalDefault = {
    horizontal: 'md' as const,
    ...padding,
  };

  return (
    <Element
      padding={paddingWithHorizontalDefault}
      className={classNames}
      tagName={tagName}
      {...props}
    >
      {children}
    </Element>
  );
};

export default MarginSpace;
